import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'gob-home-intro-anim',
  templateUrl: './home-intro-anim.component.html',
  styleUrls: ['./home-intro-anim.component.scss']
})
export class HomeIntroAnimComponent implements OnInit {

  titre: string = "Venez jouer à La Caverne du Gobelin près de chez vous !";
  description: string = "Nos cafés-jeux en Lorraine vous accueillent tous les jours du lundi au samedi pour partager des moments ludiques.";

  constructor() {}

  ngOnInit(): void {
  }
}